<template>
  <div class="register">

    <body class="account-page" style="font-family: 'CircularStd', sans-serif;
    font-size: .9375rem;
    color: #1f1f1f;
    background-color: #f7f7f7;
    min-height: 100%;
    overflow-x: hidden;
    
    ">
      <!-- Main Wrapper -->
      <div class="main-wrapper">
        <div class="account-content">
          <div class="container">
            <!-- Account Logo -->
            <div class="account-logo">
              <router-link to="/index">
                <img v-bind:src="logoText" :alt="appTitle" />
              </router-link>
            </div>
            <!-- /Account Logo -->
            <div class="row">
              <div class="col-sm-6">
                <div class="account-box">
                  <div class="account-wrapper">
                    <h3 class="account-title">Register</h3>
                    <!-- <p class="account-subtitle">Free &amp; No credit card required.</p> -->

                    <!-- Account Form -->
                    <form @submit.prevent="createValidation" class="was-validated">
                      <div class="form-group">
                        <label>Email</label>
                        <span class="text-danger">*</span>
                        <input class="form-control" type="email" v-model="fields.member_email" required />
                      </div>
                      <div class="form-group">
                        <label>Phone</label>
                        <input class="form-control" type="text" v-model="fields.member_mobilephone" />
                      </div>
                      <div class="form-group">
                        <label>Name</label>
                        <input class="form-control" type="text" v-model="fields.member_name" />
                      </div>
                      <div class="form-group">
                        <label>Password</label>
                        <span class="text-danger">*</span>
                        <input class="form-control" type="password" v-model="fields.member_password" required />
                      </div>
                      <div class="form-group">
                        <label>Repeat Password</label>
                        <span class="text-danger">*</span>
                        <input class="form-control" type="password" v-model="fields.member_repeat_password" required />
                      </div>
                      <div class="form-group">
                        <a href="javascript:void(0)" @click="toggleCouponCode">Enter Referral Code</a>
                      </div>
                      <div class="form-group" v-if="showCouponCode">
                        <label>Referral</label>
                        <input @change="detailReferral" class="form-control" type="text"
                          v-model="fields.referral_code" />
                        <span class="text-muted" v-if="referralInfo.member_name != ''">Referral Name:
                          {{ referralInfo.member_name }}</span>
                        <!-- {{referralInfo}} -->
                      </div>
                      <div class="form-group">
                        <div class="custom-control custom-checkbox mb-3">
                          <input type="checkbox" class="custom-control-input" id="customControlValidation1" required />
                          <label class="custom-control-label" for="customControlValidation1">
                            I accept
                            <router-link target="_blank" to="/terms">Terms of Service and Privacy Policy</router-link>
                          </label>
                          <!-- <div class="invalid-feedback">Example invalid feedback text</div> -->
                        </div>
                      </div>

                      <div class="form-group text-center">
                        <button :disabled="isDisabled == 1" class="btn btn-primary account-btn"
                          type="submit">Register</button>
                      </div>
                      <div class="account-footer">
                        <p>
                          Already have an account?
                          <router-link to="/login">Login</router-link>
                        </p>
                      </div>
                    </form>
                    <!-- /Account Form -->
                  </div>
                </div>
              </div>
              <div class="col-sm-6">
                <div class="card card-file">
                  <div class="text-center">
                    <a href="https://waajo.id/layanan" target="_blank">
                      <img src="https://s3-id-jkt-1.kilatstorage.id/aphrodite.enusoft.id/affiliate/af3.jpeg"
                        style="width:94%;" />
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- /Main Wrapper -->
    </body>
  </div>
</template>

<script>
import {
  removeReferralCode,
  getReferralCode,
  setReferralCode
} from "@/utils/auth";

export default {
  data() {
    return {
      token: '',
      showCouponCode: 0,
      appTitle: process.env.VUE_APP_TITLE,
      logoText: process.env.VUE_APP_LOGO_TEXT,
      isDisabled: 0,
      //   isProcessing: "",
      fields: {
        member_name: "",
        member_email: "",
        member_mobilephone: "",
        member_password: "",
        member_repeat_password: "",
        referral_id: 0,
        referral_code:
          getReferralCode() != null && getReferralCode() != ""
            ? getReferralCode()
            : ""
      },
      referralInfo: {
        id: 0,
        referral_code: "",
        member_name: ""
      }
    };
  },
  created() {
    this.recaptcha()
    var ref = this.$route.query.ref;
    if (typeof ref != "undefined" && ref != "") {
      // console.log("ref:", ref);
      this.fields.referral_code = ref;
      setReferralCode(ref);
      this.detailReferral();
      this.showCouponCode = 1;
    } else {
      let ref = getReferralCode();
      if (ref != null && ref != "") {
        this.fields.referral_code = ref;
        // setReferralCode(ref);
        this.detailReferral();
        this.showCouponCode = 1;
      }
    }

    //set setInterval recaptcha
    var that = this
    setInterval(function () {
      console.log("reload recapthca")
      that.recaptcha()
    }, 90000)
  },
  methods: {
    async recaptcha() {
      // (optional) Wait until recaptcha has been loaded.
      await this.$recaptchaLoaded()
      // Execute reCAPTCHA with action "login".
      this.token = await this.$recaptcha('registration')
      // console.log("token",this.token)
      let recaptcha = await this.$recaptchaInstance

      // Hide reCAPTCHA badge:
      // await   recaptcha.hideBadge()

      // Show reCAPTCHA badge:
      await recaptcha.showBadge()

      // Do stuff with the received token.
    },
    toggleCouponCode() {
      if (this.showCouponCode == 0) {
        this.showCouponCode = 1;
      } else {
        this.showCouponCode = 0;
      }
    },
    async detailReferral() {
      let code = this.fields.referral_code;
      if (code == "") {
        this.referralInfo = {
          id: 0,
          referral_code: "",
          member_name: ""
        };
        this.fields.referral_id = 0;
        this.showCouponCode = 0;
        return;
      }
      await this.$store
        .dispatch("referral/detail", code) // sesuai kan dengan method di API
        .then(response => {
          this.referralInfo = response.data;
          this.fields.referral_id = parseInt(this.referralInfo.id);
        })
        .catch(error => {
          removeReferralCode();
          this.referralInfo = {
            id: 0,
            referral_code: "",
            member_name: ""
          };
          this.fields.referral_id = 0;
        });
    },
    async createValidation() {
      this.isDisabled = await 1;
      if (this.fields.member_password != this.fields.member_repeat_password) {
        this.$alert("Password and Repeat Password must match");
        this.isDisabled = await 0;

        return false;
      }
      await this.$store
        .dispatch("register/createStored", { fields: this.fields, token: this.token }) // sesuai kan dengan method di API
        .then(response => {
          // console.log("response", response);
          if (response["status"] == 200) {
            let recaptcha = this.$recaptchaInstance
            recaptcha.hideBadge()

            this.$fire({
              title: "Success",
              text: "Link konfirmasi akun telah dikirimkan ke Email anda. Silakan cek di bagian Kotak Masuk atau Spam untuk melakukan verifikasi akun.",
              type: "success",
              timer: 5000
            }).then(r => {
              this.isDisabled = 0;

              //   console.log(r.value);
              //redirect to login form
              this.$router.push("/login");
            });
          }
        })
        .catch(error => {
          this.isDisabled = 0;

          //   console.log("error::", error);
        });
    }
  },
  name: "register"
};
</script>


// WEBPACK FOOTER //
// src/views/register/index.vue